import { useParams, useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useBooking } from "@/hooks/useBookings";
import BookingMarketplaceBrowser from "@/components/BookingMarketplaceBrowser";
import BreadcrumbNavigation from "@/components/BreadcrumbNavigation";
import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export default function BookingMarketplacePage() {
  const { bookingId } = useParams<{ bookingId: string }>();
  const [, setLocation] = useLocation();

  const { data: booking, loading, error } = useBooking(bookingId!);

  const breadcrumbItems = [
    { label: "Dashboard", href: "/dashboard" },
    { label: "Bookings", href: "/bookings" },
    { label: booking ? `${booking.activityName}` : "Loading...", href: `/bookings/${bookingId}` },
    { label: "Marketplace", href: "#", current: true }
  ];

  if (loading) {
    return (
      <div className="space-y-6">
        <BreadcrumbNavigation items={breadcrumbItems} />
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="sm" onClick={() => setLocation(`/bookings/${bookingId}`)}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Booking
            </Button>
            <Skeleton className="h-8 w-64" />
          </div>
          <Skeleton className="h-96 w-full" />
        </div>
      </div>
    );
  }

  if (error || !booking) {
    return (
      <div className="space-y-6">
        <BreadcrumbNavigation items={breadcrumbItems} />
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>
            {error || "Booking not found"}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <BreadcrumbNavigation items={breadcrumbItems} />

      <BookingMarketplaceBrowser bookingId={bookingId!} />
    </div>
  );
}